module.exports = __webpack_public_path__ + "static/media/dragDropIconDark.dabb812b.svg";